import React from 'react';
import Icon from '../../../components/AppIcon';

const RealtimeMonitor = ({ data }) => {
  const statusColors = {
    healthy: 'bg-green-500',
    warning: 'bg-yellow-500',
    critical: 'bg-red-500'
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg shadow-lg p-6 text-white">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/20 rounded-lg">
            <Icon name="Radio" className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold">Real-time Monitor</h2>
            <p className="text-sm text-blue-100">Live platform activity</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full ${statusColors?.[data?.systemHealth]} animate-pulse`} />
          <span className="text-sm font-medium capitalize">{data?.systemHealth}</span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Users" className="w-4 h-4 text-blue-200" />
            <span className="text-sm text-blue-100">Active Now</span>
          </div>
          <p className="text-3xl font-bold">{data?.activeNow}</p>
          <p className="text-xs text-blue-200 mt-1">Users in last 5 minutes</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Activity" className="w-4 h-4 text-blue-200" />
            <span className="text-sm text-blue-100">Concurrent Users</span>
          </div>
          <p className="text-3xl font-bold">{data?.concurrentUsers}</p>
          <p className="text-xs text-blue-200 mt-1">Currently online</p>
        </div>
      </div>
    </div>
  );
};

export default RealtimeMonitor;